import { createSlice } from "@reduxjs/toolkit";

const GlobalSlice = createSlice({
    name: "global_slice",
    initialState: {
        refresh_login: false,
        reload_profile:false,
        reload_home : false,
        reload_post:false,
        reloa_event:false,
    },
    reducers: {
        reloadState(state, action) {
            const ap = action.payload;
            if (ap['refresh_login'] != null) {
                state.refresh_login = ap['refresh_login'];
            }
            if (ap['reload_profile'] != null) {
                state.reload_profile = ap['reload_profile'];
            }
            if (ap['reload_home'] != null) {
                state.reload_home = ap['reload_home'];
            }
            if (ap['reload_post'] != null) {
                state.reload_post = ap['reload_post'];
            }
            if (ap['reloa_event'] != null) {
                state.reloa_event = ap['reloa_event'];
            }
        }
    }
});

export default GlobalSlice.reducer;
export const { reloadState } = GlobalSlice.actions;